import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../common.service";
import { CommonVariablesService } from "./../common-variables.service";
@Component({
	selector: "app-main-menus",
	templateUrl: "./main-menus.component.html",
	styleUrls: ["./main-menus.component.css"],
})
export class MainMenusComponent implements OnInit {
	public innerWidth: any;
	screenSize: any;
	resizeSize: any;
	isCollapsed = false;
	getUserProfile: any;
	getPolicyConfig: any;
	getDeclaration: boolean;
	//getSOA: boolean = false;

	constructor(
		public router: Router,
		private commonService: CommonService,
		private commonVariablesService: CommonVariablesService
	) {}

	ngOnInit() {
		// hamburger menu
		var screenSize = (this.innerWidth = window.innerWidth);
		if (screenSize <= 800) {
			this.isCollapsed = true;
		} else {
			this.isCollapsed = false;
		}
		/* let tmpUserType = this.cookie.get('userProfile'); */
		let tmpUserType = window.localStorage.getItem("userProfile");
		this.getUserProfile = this.commonService.decryptData(tmpUserType);
		let tmpUrl = this.router.url.split("/");

		this.getPolicyConfig = false;
		this.getDeclaration = false;

		if (tmpUrl[1] == "policy-configuration") {
			this.getPolicyConfig = true;
		} else if (tmpUrl[1] == "declaration") {
			this.getDeclaration = true;
		}
		/* else if (tmpUrl[1] == 'simple-statement-of-accounts') {
			this.getSOA = true;
		}
		else if (tmpUrl[1] == 'detailed-statement-of-accounts') {
			this.getSOA = true;
		} */

		/* 
		$(".menu").click(function () {
			$(this).addClass("active");
			$(".menu").not(this).removeClass("active");
			
	}); */
	}
	onResize(event) {
		var resizeSize = event.target.innerWidth;
		if (resizeSize <= 800) {
			this.isCollapsed = true;
		} else {
			this.isCollapsed = false;
		}
	}
	async gotoPage(pageName) {
		let tmpUrl: any = this.router.url.split("/");
		if (pageName == "declaration") {
			let header = JSON.parse(
				window.localStorage.getItem("declaration-header") || "{}"
			);
			if (
				(header.header_policy || "") != "" &&
				this.getUserProfile != "underwriter" &&
				this.getUserProfile != "helpdesk"
			) {
				if (tmpUrl[2] != 1) {
					this.commonService.passValue({ id: 1 });
					this.router.navigate(["/declaration", 1]);
				} else {
					this.commonService.passValue({ id: 0 });
					this.router.navigate(["/declaration", 0]);
					this.commonVariablesService.selected = "";
					this.commonVariablesService.gcPolicyNoFromHeaderSearch = "";
					await this.commonService.formMasterPolicyList("Header");
				}
			} else {
				this.commonService.passValue({ id: 0 });
				this.router.navigate(["/declaration", 0]);
				this.commonVariablesService.selected = "";
				this.commonVariablesService.gcPolicyNoFromHeaderSearch = "";
				await this.commonService.formMasterPolicyList("Header");
			}
		}
	}
}
